export default [
  {
    facet: 'somosUnitTags',
    label: 'Unit',
  },
  {
    facet: 'topicTags',
    label: 'Topics',
  },
  {
    facet: 'tenseTags',
    label: 'Level',
  },
  {
    facet: 'themeTags',
    label: 'AP Themes',
  },
  {
    facet: 'grammarTags',
    label: 'Grammar',
  },
  {
    facet: 'countryTags',
    label: 'Countries',
  },
]
